import { Handle, HandleType, Position } from '@xyflow/react';
import React from 'react';

interface ICustomHandleProps {
    type: HandleType;
    position: Position;
    bgColor: string | unknown;
    borderColor: string | unknown;
}

export const CustomHandle: React.FC<ICustomHandleProps> = ({ type, position, bgColor, borderColor }) => {
    return <Handle style={{ width: '10px', height: '10px', backgroundColor: bgColor as string, border: `2px solid ${borderColor}` }} type={type} position={position} isConnectable={true} />;
};
